import React, { useEffect, useMemo, useState } from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { changeLanguage } from "../../i18n";

type LangOption = { label: string; value: "tr" | "en" };

const LanguageSwitcher: React.FC = () => {
  const [currentLanguage, setCurrentLanguage] = useState<"tr" | "en">("tr");

  // Seçenekleri sabitle
  const languageOptions: LangOption[] = useMemo(
    () => [
      { label: "TR", value: "tr" },
      { label: "EN", value: "en" },
    ],
    []
  );

  // İlk yüklemede localStorage'dan al
  useEffect(() => {
    const saved = localStorage.getItem("language");
    if (saved === "tr" || saved === "en") {
      setCurrentLanguage(saved);
    }
  }, []);

  const onChange = (e: DropdownChangeEvent) => {
    const next = e.value as "tr" | "en";
    setCurrentLanguage(next);
    changeLanguage(next);
    localStorage.setItem("language", next);
  };

  return (
    <div className="flex items-center gap-2">
      {/*       <img src="/icons/planet-earth.png" alt="Language" className="w-6 h-6" />
       */}{" "}
      <Dropdown
        value={currentLanguage} // <-- primitive değer
        options={languageOptions}
        optionLabel="label"
        optionValue="value" // <-- value alanını kullan
        onChange={onChange}
        className="w-16"
        panelClassName="language-dropdown-panel"
        placeholder="Dil"
      />
    </div>
  );
};

export default LanguageSwitcher;
